module.exports = __webpack_public_path__ + "static/media/archery-world-tour.8807a3af.jpg";